var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 84,
    viewBox: "0 0 216 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 0H79a4 4 0 0 0-4 4v76H46c-3.866 0-7-3.582-7-8s3.134-8 7-8H7c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c3.866 0 7-3.582 7-8s-3.134-8-7-8H22c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c-3.866 0-7-3.582-7-8s3.134-8 7-8h37Zm42.734 16H183c3.866 0 7 3.582 7 8s-3.134 8-7 8h22c3.866 0 7 3.582 7 8s-3.134 8-7 8h-19c-3.866 0-7 3.582-7 8s3.134 8 7 8h6c3.866 0 7 3.582 7 8s-3.134 8-7 8h-50V17.435c0-.495-.092-.981-.266-1.435ZM209 80c-3.866 0-7-3.582-7-8s3.134-8 7-8 7 3.582 7 8-3.134 8-7 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 1.25A2.75 2.75 0 0 0 76.25 4v76A2.75 2.75 0 0 0 79 82.75h59a2.75 2.75 0 0 0 2.75-2.75V17.435c0-.73-.29-1.43-.806-1.945L126.5 2.055a2.75 2.75 0 0 0-1.944-.805H79Z",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 2.403V14a3 3 0 0 0 3 3h11.66M108 42.5v18-18Zm-31 0h31-31Zm0 18h31-31Z",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NotoSans-Bold, Noto Sans",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.9,
    fill: "#6A6666"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    y: 55
  }, ".INI")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectives);
export default __webpack_public_path__ + "static/media/directives.bc88014eb617292135e42c54f22df776.svg";
export { ForwardRef as ReactComponent };